import { useState } from 'react';
import { Container, Table, Card, Row, Col, Modal } from "react-bootstrap";
import './facilities.css';
import { GiCheckMark } from "react-icons/gi";

function MyVerticallyCenteredModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Pricing
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Table striped bordered hover responsive="sm md lg xl">
                        <thead>
                            <tr>
                                <th>Room Category</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{props.valPrice.roomOne}</td>
                                <td>{props.valPrice.roomOnePrice}</td>
                            </tr>
                            <tr>
                                <td>{props.valPrice.roomTwo}</td>
                                <td>{props.valPrice.roomTwoPrice}</td>
                            </tr>
                            <tr>
                                <td>{props.valPrice.roomThree}</td>
                                <td>{props.valPrice.roomThreePrice}</td>
                            </tr>
                            <tr>
                                <td>{props.valPrice.roomFour}</td>
                                <td>{props.valPrice.roomFourPrice}</td>
                            </tr>
                            <tr>
                                <td>{props.valPrice.roomFive}</td>
                                <td>{props.valPrice.roomFivePrice}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Container>
            </Modal.Body>
        </Modal>
    );
}


const Facilities = (props) => {
    const [modalShow, setModalShow] = useState(false);
    const [cardIndex, setCardIndex] = useState(0);
    const sectionTitle = props.valBody.attributes.price_text.split(" ");

    return (
            <section id="facilities">
                <Container >

                    {/* <h2>{props.valBody.attributes.price_text}</h2> */}
                    <h2 className="sectionHeading titles">
                        <span className='titles-black me-2'>{sectionTitle[0]}</span>
                        <span className='titles-black me-2'>{sectionTitle[1]}</span>
                        <span className='me-2'>{sectionTitle[2]}</span>
                        <span className='me-2'>{sectionTitle[3]}</span>
                        <span>{sectionTitle[4]}</span>
                    </h2>
                    {/* <div className='hr-center'>
                        <hr style={{ height: '3px', width: '4rem', color: 'dark' }} />
                    </div> */}

                    <div>
                        <div className="mb-3">
                            <Row md={4} lg={4} sm={3} xs={1} xxl={5}>

                                {props.valBody.attributes.pricing.map((data, index) => (

                                    <div className="card-center" key={Math.random()}>

                                        <Col className="mb-3" lg={4} md={6} sm={3} xxl={5} key={Math.random()}>
                                            <Card className="cursor-click pricing-animation pricecard" onClick={() => { setModalShow(true); setCardIndex(index) }}>
                                                <Card.Img src={data.cardImg.data[0].attributes.formats.thumbnail.url} height="100" alt="Card image" />
                                                <Card.ImgOverlay className="img-overlay-bg">
                                                    <p className="centered text-white">{data.cardTitle}</p>
                                                </Card.ImgOverlay>
                                            </Card>
                                        </Col>
                                    </div>
                                ))}
                            </Row>

                            <MyVerticallyCenteredModal
                                show={modalShow}
                                onHide={() => setModalShow(false)}
                                valPrice={props.valBody.attributes.pricing[cardIndex]}
                            />
                        </div>
                        <div className='py-5'>
                            {/* <Card className="text-white mb-5 facility">
                        <Card.Img src={props.valBody.pricingImg[0].formats.large.url} className="facility-img" alt="Card image" />
                        <Card.ImgOverlay>
                            <Card.Text>
                                <h4>Important tags</h4>
                                <hr style={{ height: '2px', width: '4rem', color: 'dark' }} />
                            </Card.Text>
                            <Card.Text className="mb-5">
                                <p>
                                    <GiCheckMark /> {props.valBody.pricetagone}
                                </p>
                                <p>
                                    <GiCheckMark />  {props.valBody.pricetagtwo}
                                </p>
                            </Card.Text>
                            <Card.Text>{props.valBody.pricetagthree}</Card.Text>
                        </Card.ImgOverlay>
                    </Card> */}
                            <div className="mb-3">
                                <h4>
                                    Important tags
                                </h4>
                                <hr style={{ height: '2px', width: '4rem', color: 'dark' }} />
                            </div>
                            <div>
                                <p>
                                    <GiCheckMark /> {props.valBody.attributes.note_tagTwo}
                                </p>
                                <p>
                                    <GiCheckMark />  {props.valBody.attributes.note_tagThree}
                                </p>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
    );
};

export default Facilities